import axios from 'axios'
import AuthClientConfig from '../../utils/helpers/AuthHelper'
import { IDMSERVICE_BASE_URL } from '../../envVariables'

export interface UserAppModel {
  id: number | undefined
  identifier: string | undefined
  name: string | undefined
  description: string | undefined
  category: string | undefined
  launchUri: string | undefined
  logoUri: string | undefined
  brandedApplicationType: string | undefined
}

const getReportPath = (uri: string): string => {
  const comIndex = uri.indexOf('.com')
  if (comIndex === -1) {
    return uri // ".com" not found, return the original URI
  }

  return uri.substring(comIndex + 4) // Return the substring after ".com";
}

export const getUserApps = async (): Promise<UserAppModel[]> => {
  const path = `${IDMSERVICE_BASE_URL}/api/BrandedApplications/myauthorizedapps`
  const token = await new AuthClientConfig().getAuthorization()

  const response = await axios.get(path, { headers: { Authorization: token } })

  const result =
    response.data.map((a: UserAppModel) => ({
      id: a.id,
      identifier: a.identifier,
      name: a.name,
      description: a.description,
      category: a.category,
      launchUri: a.launchUri?.includes('.rsmus.com/report/')
        ? getReportPath(a.launchUri)
        : a.launchUri,
      logoUri: a.logoUri,
      brandedApplicationType: a.brandedApplicationType,
    })) ?? []

  return result
}
